<!-- superadmin-dashboard.component.html -->

<div class="sad">

  <!-- ── Header ──────────────────────────────────── -->
  <div class="sad__header">
    <div>
      <h1 class="sad__title">Platform Overview</h1>
      <p class="sad__subtitle">Real-time metrics across all companies on FieldOps.</p>
    </div>
    <div class="sad__header-right">
      <span class="sad__date">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.8"/>
          <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="1.8"/>
          <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        {{ today | date:'EEEE, MMM d, y' }}
      </span>
    </div>
  </div>

  <!-- ── Loading ──────────────────────────────────── -->
  <div class="sad__loading" *ngIf="loading">
    <div class="sad__spinner"></div>
    <span>Loading platform data…</span>
  </div>

  <!-- ── Stats Grid ───────────────────────────────── -->
  <div class="sad__stats" *ngIf="!loading && stats">

    <div class="sad__stat-card sad__stat-card--companies">
      <div class="sad__stat-inner">
        <div class="sad__stat-body">
          <span class="sad__stat-label">Total Companies</span>
          <span class="sad__stat-val">{{ stats.totalCompanies }}</span>
          <span class="sad__stat-sub">
            <span class="sad__pill sad__pill--gold">+{{ stats.companiesThisMonth }} this month</span>
          </span>
        </div>
        <div class="sad__stat-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M3 21V7L12 3L21 7V21" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="9" y="14" width="6" height="7" rx="1" stroke="currentColor" stroke-width="1.8"/>
            <rect x="5" y="10" width="3" height="3" rx=".5" stroke="currentColor" stroke-width="1.5"/>
            <rect x="16" y="10" width="3" height="3" rx=".5" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        </div>
      </div>
      <div class="sad__stat-bar"></div>
    </div>

    <div class="sad__stat-card sad__stat-card--workers">
      <div class="sad__stat-inner">
        <div class="sad__stat-body">
          <span class="sad__stat-label">Total Workers</span>
          <span class="sad__stat-val">{{ stats.totalWorkers }}</span>
          <span class="sad__stat-sub">
            <span class="sad__pill sad__pill--blue">{{ stats.totalAdmins }} admins</span>
          </span>
        </div>
        <div class="sad__stat-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
            <path d="M2 20C2 17 5 14 9 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <path d="M16 14C19.3 14 22 16.7 22 20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <circle cx="17" cy="10" r="3" stroke="currentColor" stroke-width="1.8"/>
          </svg>
        </div>
      </div>
      <div class="sad__stat-bar"></div>
    </div>

    <div class="sad__stat-card sad__stat-card--jobs">
      <div class="sad__stat-inner">
        <div class="sad__stat-body">
          <span class="sad__stat-label">Total Jobs</span>
          <span class="sad__stat-val">{{ stats.totalJobs }}</span>
          <span class="sad__stat-sub">
            <span class="sad__pill sad__pill--green">Platform wide</span>
          </span>
        </div>
        <div class="sad__stat-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/>
            <path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </div>
      </div>
      <div class="sad__stat-bar"></div>
    </div>

    <div class="sad__stat-card sad__stat-card--logs">
      <div class="sad__stat-inner">
        <div class="sad__stat-body">
          <span class="sad__stat-label">Total Logs</span>
          <span class="sad__stat-val">{{ stats.totalLogs }}</span>
          <span class="sad__stat-sub">
            <span class="sad__pill sad__pill--teal">{{ stats.totalHours | number:'1.0-0' }}h logged</span>
          </span>
        </div>
        <div class="sad__stat-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </div>
      </div>
      <div class="sad__stat-bar"></div>
    </div>

  </div>

  <!-- ── Bottom Grid ───────────────────────────────── -->
  <div class="sad__grid" *ngIf="!loading">

    <!-- Recent Companies -->
    <div class="sad__panel">

      <div class="sad__panel-head">
        <div class="sad__panel-head-left">
          <h3 class="sad__panel-title">Recent Companies</h3>
          <span class="sad__panel-count">{{ companies.length }}</span>
        </div>
        <a routerLink="/superadmin/companies" class="sad__panel-link">
          View all
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
            <path d="M5 12H19M13 6L19 12L13 18" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>

      <!-- Empty -->
      <div class="sad__panel-empty" *ngIf="companies.length === 0">
        <p>No companies registered yet.</p>
      </div>

      <!-- List -->
      <div class="sad__company-list" *ngIf="companies.length > 0">
        <div class="sad__company-row"
             *ngFor="let c of recentCompanies"
             [routerLink]="['/superadmin/companies', c.id]">

          <div class="sad__company-avatar">
            {{ c.name.charAt(0).toUpperCase() }}
          </div>

          <div class="sad__company-info">
            <span class="sad__company-name">{{ c.name }}</span>
            <span class="sad__company-meta">
              {{ c.workerCount }} workers · {{ c.jobCount }} jobs
            </span>
          </div>

          <div class="sad__company-right">
            <span class="sad__company-status"
                  [class.sad__company-status--active]="c.isActive"
                  [class.sad__company-status--suspended]="!c.isActive">
              <span class="sad__company-status-dot"></span>
              {{ c.isActive ? 'Active' : 'Suspended' }}
            </span>
            <span class="sad__company-date">{{ c.createdUtc | date:'MMM d, y' }}</span>
          </div>

        </div>
      </div>

    </div>

    <!-- Platform Summary -->
    <div class="sad__panel">

      <div class="sad__panel-head">
        <div class="sad__panel-head-left">
          <h3 class="sad__panel-title">Platform Summary</h3>
        </div>
      </div>

      <div class="sad__summary-list" *ngIf="stats">

        <div class="sad__summary-row">
          <div class="sad__summary-icon sad__summary-icon--gold">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path d="M3 21V7L12 3L21 7V21" stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="sad__summary-body">
            <span class="sad__summary-label">Companies registered this month</span>
            <span class="sad__summary-val">{{ stats.companiesThisMonth }}</span>
          </div>
        </div>

        <div class="sad__summary-row">
          <div class="sad__summary-icon sad__summary-icon--blue">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.8"/>
              <path d="M4 20C4 17 7.6 14 12 14C16.4 14 20 17 20 20"
                    stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </div>
          <div class="sad__summary-body">
            <span class="sad__summary-label">Avg workers per company</span>
            <span class="sad__summary-val">{{ avgWorkersPerCompany }}</span>
          </div>
        </div>

        <div class="sad__summary-row">
          <div class="sad__summary-icon sad__summary-icon--green">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/>
              <path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7"
                    stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </div>
          <div class="sad__summary-body">
            <span class="sad__summary-label">Avg jobs per company</span>
            <span class="sad__summary-val">{{ avgJobsPerCompany }}</span>
          </div>
        </div>

        <div class="sad__summary-row">
          <div class="sad__summary-icon sad__summary-icon--teal">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
              <polyline points="12 6 12 12 16 14" stroke="currentColor" stroke-width="1.8"
                        stroke-linecap="round"/>
            </svg>
          </div>
          <div class="sad__summary-body">
            <span class="sad__summary-label">Total hours logged platform-wide</span>
            <span class="sad__summary-val">{{ stats.totalHours | number:'1.0-0' }}h</span>
          </div>
        </div>

        <div class="sad__summary-row">
          <div class="sad__summary-icon sad__summary-icon--purple">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"
                        stroke="currentColor" stroke-width="1.8"
                        stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="sad__summary-body">
            <span class="sad__summary-label">Avg logs per company</span>
            <span class="sad__summary-val">{{ avgLogsPerCompany }}</span>
          </div>
        </div>

      </div>

    </div>

  </div>

</div>